import React from 'react';
import { useSelector } from 'react-redux';

import { activeNetworkSelector } from 'redux/selectors';
import { MessageBlock } from '@getro/rombo';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import MainLayout from '../../components/layout/Main';
import { ConnectHome } from './connectHome';

const Home = () => {
  const { connect } = useSelector(activeNetworkSelector);

  return (
    <MainLayout>
      <MainLayoutHeader title="Home" />
      {connect?.hasAccess ? (
        <ConnectHome />
      ) : (
        <MessageBlock
          type="warning"
          title="No access"
          content="Sorry, you don't have the necessary permissions to access this page."
        />
      )}
    </MainLayout>
  );
};

export default Home;
